import { render } from "./ClientList.vue?vue&type=template&id=48d07dab"
import script from "./ClientList.vue?vue&type=script&lang=js"
export * from "./ClientList.vue?vue&type=script&lang=js"
script.render = render

export default script